import { ConstructionCredits } from "../enums/ConstructionCredits";
import { AdditionalInvoiceData } from "./AdditionalInvoiceData";
import { InvoiceBus } from "./InvoiceBus";

//this class is used in conjuction with the Invoice menu option 
//Create Credit Memo and Correction which is a "isConstructionOnly"
//feature on the Invoice page
export class ConstructionCredit {
    constructor(
        public constructionCreditType: ConstructionCredits, 
        public hasSavedCreditMemo: boolean, 
        public data: InvoiceBus, 
        public addtlData: AdditionalInvoiceData,
        public creditMemoInvoiceNumber: string, 
        public reloadInvoiceId: string) {}
}